import React from 'react';
import LegalPage from './LegalPage';

export default function Privacy() {
  return <LegalPage pageKey="privacy" />;
}
